(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
(function () {
  const drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  const itemsEl = drawer.querySelector('[data-cart-items]');
  const emptyEl = drawer.querySelector('[data-cart-empty]');
  const footEl = drawer.querySelector('[data-cart-drawer-foot]');
  const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
  const cartTriggers = document.querySelectorAll('.site-header__cart, [data-cart-open]');
  const closeTriggers = drawer.querySelectorAll('[data-cart-drawer-close]');

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' $';
  }

  function render(cart) {
    const items = cart.items || [];
    if (!items.length) {
      itemsEl.innerHTML = '';
      emptyEl.hidden = false;
      footEl.hidden = true;
      return;
    }
    emptyEl.hidden = true;
    footEl.hidden = false;
    itemsEl.innerHTML = items.map(item => `
      <li class="cart-drawer__item" data-key="${item.key}">
        <img class="cart-drawer__item-img" src="${item.featured_image && item.featured_image.url ? item.featured_image.url + '&width=160' : ''}" alt="${item.product_title}" loading="lazy">
        <div class="cart-drawer__item-info">
          <span class="cart-drawer__item-title">${item.product_title}</span>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="cart-drawer__item-variant">${item.variant_title}</span>` : ''}
          <div class="cart-drawer__item-qty">
            <button type="button" class="cart-drawer__qty-btn" data-qty-minus aria-label="Réduire">−</button>
            <span class="cart-drawer__qty-value">${item.quantity}</span>
            <button type="button" class="cart-drawer__qty-btn" data-qty-plus aria-label="Augmenter">+</button>
          </div>
          <button type="button" class="cart-drawer__item-remove" data-remove>Retirer</button>
        </div>
        <span class="cart-drawer__item-price">${formatMoney(item.line_price)}</span>
      </li>
    `).join('');
    subtotalEl.textContent = formatMoney(cart.total_price);

    itemsEl.querySelectorAll('[data-key]').forEach(li => {
      const key = li.dataset.key;
      const qtyVal = li.querySelector('.cart-drawer__qty-value');
      li.querySelector('[data-qty-minus]').addEventListener('click', () => updateQty(key, Math.max(0, parseInt(qtyVal.textContent) - 1)));
      li.querySelector('[data-qty-plus]').addEventListener('click', () => updateQty(key, parseInt(qtyVal.textContent) + 1));
      li.querySelector('[data-remove]').addEventListener('click', () => updateQty(key, 0));
    });
  }

  async function fetchCart() {
    const r = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    return r.json();
  }
  async function updateQty(key, qty) {
    const r = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    const cart = await r.json();
    render(cart);
  }

  function open() {
    drawer.hidden = false;
    requestAnimationFrame(() => drawer.classList.add('is-open'));
    fetchCart().then(render);
    document.body.style.overflow = 'hidden';
  }
  function close() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, 500);
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    open();
  }));
  closeTriggers.forEach(t => t.addEventListener('click', close));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });

  document.addEventListener('cart:added', () => open());

  window.PDV_cart = { open, close, refresh: () => fetchCart().then(render) };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["drops-passes"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-drops-reveal]').forEach(media => {
    media.addEventListener('click', (e) => {
      e.preventDefault();
      media.classList.toggle('is-revealed');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  const lists = document.querySelectorAll('[data-faq]');
  lists.forEach(list => {
    const items = list.querySelectorAll('.faq__item');
    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (item.open) {
          items.forEach(other => { if (other !== item) other.open = false; });
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  const STORAGE_KEY = 'pdv:patreon-banner:dismissed';
  const banner = document.querySelector('[data-patreon-banner]');
  if (!banner) return;
  if (sessionStorage.getItem(STORAGE_KEY) === '1') {
    banner.hidden = true;
  }
  const closeBtn = banner.querySelector('[data-patreon-close]');
  closeBtn?.addEventListener('click', () => {
    banner.hidden = true;
    sessionStorage.setItem(STORAGE_KEY, '1');
  });

  const header = document.querySelector('.site-header');
  let lastY = 0;
  window.addEventListener('scroll', () => {
    const y = window.scrollY;
    header.dataset.scrolled = y > 20 ? 'true' : 'false';
    lastY = y;
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const stage = document.querySelector('.hero__stage');
  if (!stage) return;

  const mobileSet = stage.querySelector('.hero__hoodie--mobile');
  const desktopSet = stage.querySelector('.hero__hoodie--desktop');

  const mobileSequence = ['back', 'front'];
  const mobileHolds = [2400, 2400];
  const desktopSequence = ['back', 'front'];
  const desktopHolds = [2400, 2400];
  const FADE = reducedMotion ? 1500 : 800;

  function rotate(setEl, sequence, holds) {
    const frames = Array.from(setEl.querySelectorAll('.hero__frame'));
    if (frames.length < 2) return;
    let step = 0;
    let timer = null;
    function show(name) {
      frames.forEach(f => {
        if (f.dataset.frame === name) {
          f.style.zIndex = '2';
          f.classList.add('is-active');
        } else if (f.classList.contains('is-active')) {
          f.style.zIndex = '1';
          setTimeout(() => { if (f.dataset.frame !== name) f.classList.remove('is-active'); }, FADE);
        } else {
          f.style.zIndex = '0';
        }
      });
    }
    function tick() {
      show(sequence[step]);
      const wait = (reducedMotion ? Math.max(holds[step], 2500) : holds[step]) + FADE;
      step = (step + 1) % sequence.length;
      timer = setTimeout(tick, wait);
    }
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) { clearTimeout(timer); }
      else { tick(); }
    });
    tick();
  }

  if (mobileSet) rotate(mobileSet, mobileSequence, mobileHolds);
  if (desktopSet) rotate(desktopSet, desktopSequence, desktopHolds);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lifestyle"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.currentScript ? document.currentScript.closest('.lifestyle') : null;
  document.querySelectorAll('.lifestyle').forEach(ls => {
    const grid = ls.querySelector('.lifestyle__grid');
    const dotsWrap = ls.querySelector('[data-lifestyle-dots]');
    if (!grid || !dotsWrap) return;

    const items = Array.from(grid.querySelectorAll('.lifestyle__item'));
    const mq = window.matchMedia('(max-width: 639px)');

    function buildDots() {
      dotsWrap.innerHTML = '';
      if (!mq.matches) return;
      // order items by CSS order value to match visual sequence
      const ordered = items.slice().sort((a, b) => {
        const oa = parseInt(getComputedStyle(a).order) || 0;
        const ob = parseInt(getComputedStyle(b).order) || 0;
        return oa - ob;
      });
      ordered.forEach((item, i) => {
        const dot = document.createElement('span');
        dot.className = 'lifestyle__dot' + (i === 0 ? ' is-active' : '');
        dot.addEventListener('click', () => item.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' }));
        dotsWrap.appendChild(dot);
      });
      return ordered;
    }

    let ordered = buildDots();

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        if (!mq.matches || !ordered) return;
        entries.forEach(e => {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            const idx = ordered.indexOf(e.target);
            const dots = dotsWrap.querySelectorAll('.lifestyle__dot');
            dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
          }
        });
      }, { root: grid, threshold: [0.6] });
      items.forEach(item => io.observe(item));
    }

    mq.addEventListener('change', () => { ordered = buildDots(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notify"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.querySelector('[data-notify-form]');
  if (!form) return;
  const input = form.querySelector('[data-notify-input]');
  const label = form.querySelector('[data-notify-label]');
  const feedback = form.querySelector('[data-notify-feedback]');
  const submit = form.querySelector('button[type="submit"]');
  const originalLabel = label.textContent;

  function show(message, kind) {
    feedback.textContent = message;
    feedback.classList.remove('is-error', 'is-success');
    feedback.classList.add('is-visible', kind === 'error' ? 'is-error' : 'is-success');
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = (input.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      show("Entre un courriel valide.", 'error');
      input.focus();
      return;
    }
    submit.disabled = true;
    label.textContent = 'Envoi…';

    try {
      const formData = new FormData(form);
      await fetch(form.action, { method: 'POST', body: formData, mode: 'no-cors' });
      show('✓ T’es sur la liste.', 'success');
      input.value = '';
      label.textContent = originalLabel;
      submit.disabled = false;
    } catch (err) {
      show('Oups, réessaie dans un instant.', 'error');
      label.textContent = originalLabel;
      submit.disabled = false;
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-feature"] && !Shopify.designMode) return;
  try {
    
(function () {
  const section = document.querySelector('[data-section-id]');
  document.querySelectorAll('.product-feature').forEach(pf => {
    const thumbs = pf.querySelectorAll('[data-pf-thumb]');
    const slides = pf.querySelectorAll('[data-pf-slide]');
    const main = pf.querySelector('.product-feature__main');
    const isMobile = () => window.matchMedia('(max-width: 899px)').matches;

    function activate(i) {
      thumbs.forEach(x => x.classList.toggle('is-active', x.dataset.index === String(i)));
      slides.forEach(x => x.classList.toggle('is-active', x.dataset.index === String(i)));
    }

    thumbs.forEach(t => {
      t.addEventListener('click', () => {
        const i = t.dataset.index;
        activate(i);
        if (isMobile() && main) {
          const slide = pf.querySelector(`[data-pf-slide][data-index="${i}"]`);
          slide?.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
        }
      });
    });

    if (main && 'IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting && e.intersectionRatio > 0.6) {
            const i = e.target.dataset.index;
            thumbs.forEach(x => x.classList.toggle('is-active', x.dataset.index === i));
          }
        });
      }, { root: main, threshold: [0.6] });
      slides.forEach(s => io.observe(s));
    }

    const sizeGuideBtn = pf.querySelector('[data-size-guide-open]');
    const sizeGuide = document.querySelector('[data-size-guide]');
    if (sizeGuideBtn && sizeGuide) {
      sizeGuideBtn.addEventListener('click', () => sizeGuide.showModal());
    }

    const form = pf.querySelector('[data-pf-form]');
    async function addToCart() {
      if (!form) return;
      const submit = form.querySelector('[data-pf-submit]');
      const label = form.querySelector('[data-pf-cta-label]');
      const originalLabel = label.textContent;
      submit.disabled = true;
      label.textContent = 'Ajout…';
      try {
        const data = new FormData(form);
        const r = await fetch('/cart/add.js', { method: 'POST', body: data, headers: { 'Accept': 'application/json' } });
        if (!r.ok) throw new Error('Cart add failed');
        label.textContent = '✓ Ajouté';
        document.dispatchEvent(new CustomEvent('cart:added'));
        setTimeout(() => { label.textContent = originalLabel; submit.disabled = false; }, 1400);
      } catch (err) {
        label.textContent = 'Erreur, réessaie';
        setTimeout(() => { label.textContent = originalLabel; submit.disabled = false; }, 2000);
      }
    }
    if (form) {
      form.addEventListener('submit', (e) => { e.preventDefault(); addToCart(); });
    }

    /* Sticky CTA mobile */
    const sticky = document.querySelector('[data-product-sticky]');
    if (sticky) {
      const SESSION_KEY = 'pdv:sticky-cta:dismissed';
      let dismissed = sessionStorage.getItem(SESSION_KEY) === '1';
      sticky.dataset.armed = 'true';

      if ('IntersectionObserver' in window) {
        const sentinel = pf.querySelector('.product-feature__form') || pf;
        const io2 = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            const pastProduct = e.boundingClientRect.bottom < 0;
            if (pastProduct && !dismissed) sticky.classList.add('is-visible');
            else sticky.classList.remove('is-visible');
          });
        }, { threshold: 0 });
        io2.observe(sentinel);
      }

      sticky.querySelector('[data-sticky-close]')?.addEventListener('click', () => {
        dismissed = true;
        sticky.classList.remove('is-visible');
        sessionStorage.setItem(SESSION_KEY, '1');
      });
      sticky.querySelector('[data-sticky-cta]')?.addEventListener('click', addToCart);
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
